/*
 * @Author: Marte
 * @Date:   2017-10-24 15:03:02
 * @Last Modified by:   Marte
 * @Last Modified time: 2017-12-04 17:47:00
 */

'use strict';
angular.module('myResourcesModule', [
    'myResourcesRouterModule',
    'myResourcesLeftModule',
    'myResourcesServiceModule',
    'subscriptionFolderModule',
    'myResourcesSearchModule'
]);